import * as R from 'ramda';

import { isValueExist } from './utils';
import { FILTER_KEYS } from './consts';

const { AD_ACCOUNT_ID } = FILTER_KEYS;

export const makeFilterFromFolderWhere = (where) => {
    const values = R.pathOr([], PATH_TO_FOLDER_VALUES_FROM_WHERE, where);

    return values.reduce((acc, channelId) => {
        return isValueExist(channelId)
            ? R.append({ filterBy: channelId, type: AD_ACCOUNT_ID }, acc)
            : acc;
    }, []);
};

export const PATH_TO_FOLDER_VALUES_FROM_WHERE = [0, 'values'];

const dropFalsyIds = R.filter(R.identity);

export const resolveTeamspaceAllowedChannelIds = (passedIds) => {
    if (Array.isArray(passedIds)) {
        return dropFalsyIds(passedIds);
    }

    if (passedIds !== null && passedIds !== undefined) {
        console.warn(
            '[teamspaceAllowedChannelIds] expected string[] | null | undefined, got',
            passedIds
        );
    }

    return null;
};

export const resolveTeamspaceAllowedAssetIds = (passedIds) => {
    if (Array.isArray(passedIds)) {
        // assetId is a DB-generated primary key starting at 1, so 0 never occurs as a real id -- dropping falsy values is safe.
        return dropFalsyIds(passedIds);
    }

    if (passedIds !== null && passedIds !== undefined) {
        console.warn(
            '[teamspaceAllowedAssetIds] expected number[] | null | undefined, got',
            passedIds
        );
    }

    return null;
};
